/**
 * Firebase Notification Test Script
 * 
 * This file provides a simple way to test the Firebase notifications functionality
 * You can import and use these functions in any component to test notifications
 */

import FirebaseService from './FirebaseService';

/**
 * Test function to check if Firebase initialization works properly
 * This will request notification permission and attempt to get a token
 */
export const testFirebaseInit = async () => {
  console.log('Testing Firebase initialization...');
  try {
    const token = await FirebaseService.initializeFirebase();
    
    if (token) {
      console.log('✅ Firebase initialized successfully!');
      console.log('FCM Token:', token);
      return token;
    } else {
      console.warn('⚠️ Firebase initialized but no token was returned');
      console.log('This could be because permission was denied or there was an issue with Firebase');
      return null;
    }
  } catch (error) {
    console.error('❌ Error initializing Firebase:', error);
    return null;
  }
};

/**
 * Test function to set up a message listener
 */
export const testMessageListener = () => {
  console.log('Setting up test message listener...');
  
  return FirebaseService.setupMessageListener(payload => {
    console.log('✅ Received test message!', payload);
    
    // Display a browser notification for testing
    if (payload.notification) {
      const { title, body } = payload.notification;
      
      if (Notification.permission === 'granted') {
        new Notification(title || 'Test Notification', {
          body: body || 'This is a test notification',
          icon: '/logo192.png'
        });
      }
    }
  });
};

/**
 * Run a full test of the Firebase functionality
 */
export const runFullFirebaseTest = async () => {
  console.log('Running full Firebase notification test...');
  
  const token = await testFirebaseInit();
  
  if (token) {
    const unsubscribe = testMessageListener();
    console.log('Message listener set up. Waiting for messages...');
    console.log('To test, send a notification to this device from the Firebase console');
    
    return () => {
      if (unsubscribe && typeof unsubscribe === 'function') {
        unsubscribe();
        console.log('Message listener unsubscribed');
      }
    };
  } else {
    console.error('Cannot set up message listener without a valid FCM token');
    return null;
  }
};

export default {
  testFirebaseInit,
  testMessageListener,
  runFullFirebaseTest
};
